import { HttpMethod } from '../../constants';
function replaceEnterpriseId(enterpriseId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId);
}
function replaceQuestionId(questionId: string): string {
  return this.path.replace(':questionId', questionId);
}
function replaceQuestionIdAndAttributeId(questionId: string, attributeId: string): string {
  return this.path.replace(':questionId', questionId).replace(':attributeId', attributeId);
}
export const attributeEndpoints = {
  [HttpMethod.Get]: {
    Attributes: {
      path: '/enterprises/:enterpriseId/attributes',
      route: replaceEnterpriseId
    }
  },
  [HttpMethod.Post]: {
    LinkQuestionToAttribute: {
      path: '/questions/:questionId/attributes',
      route: replaceQuestionId
    }
  },
  [HttpMethod.Delete]: {
    UnlinkQuestionFromAttribute: {
      path: '/questions/:questionId/attributes/:attributeId',
      route: replaceQuestionIdAndAttributeId
    }
  }
};
export default attributeEndpoints;